var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTowerBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23007 1.95257L3.75866 2.42398C1.41552 4.76712 1.41552 8.56611 3.75866 10.9093L4.23007 11.3807L3.28726 12.3235L2.81585 11.8521C-0.0479922 8.98822 -0.0479922 4.34501 2.81585 1.48117L3.28726 1.00977L4.23007 1.95257Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7156 1.00977L13.187 1.48117C16.0509 4.34501 16.0509 8.98822 13.187 11.8521L12.7156 12.3235L11.7728 11.3807L12.2442 10.9093C14.5874 8.56611 14.5874 4.76712 12.2442 2.42398L11.7728 1.95257L12.7156 1.00977Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11583 3.83799L5.64443 4.3094C4.34268 5.61114 4.34268 7.72169 5.64443 9.02344L6.11583 9.49484L5.17302 10.4377L4.70162 9.96625C2.87917 8.1438 2.87917 5.18903 4.70162 3.36659L5.17302 2.89518L6.11583 3.83799Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8296 2.89518L11.301 3.36659C13.1234 5.18903 13.1234 8.1438 11.301 9.96625L10.8296 10.4377L9.88677 9.49484L10.3582 9.02344C11.6599 7.72169 11.6599 5.61114 10.3582 4.3094L9.88677 3.83799L10.8296 2.89518Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00145 6.66612C6.00145 5.56155 6.89688 4.66612 8.00145 4.66612C9.10602 4.66612 10.0014 5.56155 10.0014 6.66612C10.0014 7.53693 9.44491 8.27775 8.66812 8.55231V14.6661H7.33478V8.55231C6.55799 8.27775 6.00145 7.53693 6.00145 6.66612ZM8.00145 5.99945C7.63326 5.99945 7.33478 6.29793 7.33478 6.66612C7.33478 7.03431 7.63326 7.33278 8.00145 7.33278C8.36964 7.33278 8.66812 7.03431 8.66812 6.66612C8.66812 6.29793 8.36964 5.99945 8.00145 5.99945Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerBroadcast);
export default __webpack_public_path__ + "static/media/tower-broadcast.ec3b79f42a736fdaf73cd4469bfe3473.svg";
export { ForwardRef as ReactComponent };